export var SubMenuName;
(function (SubMenuName) {
    SubMenuName[SubMenuName["none"] = 0] = "none";
    SubMenuName[SubMenuName["myaccount"] = 1] = "myaccount";
    SubMenuName[SubMenuName["about"] = 2] = "about";
})(SubMenuName || (SubMenuName = {}));
//# sourceMappingURL=types.js.map